import { Link } from "react-router-dom";
import { boards } from "@/mocks/boards";
import { siteInfo } from "@/mocks/site";

const helpLinks = [
  { label: "常见问题", to: "/#faq" },
  { label: "社区价值", to: "/#values" },
  { label: "关于我们", to: "/about" },
  { label: "讨论版首页", to: "/topics" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-primary-50">
      <div className="mx-auto max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50">
                <i className="ri-plant-fill" />
              </span>
              <span className="font-brand text-xl text-background-50">{siteInfo.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-100/85">{siteInfo.slogan}。</p>
            <div className="mt-4 space-y-1.5 text-sm text-primary-100/80">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line" />
                {siteInfo.email}
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-time-line" />
                {siteInfo.workTime}
              </p>
            </div>
          </div>

          <div>
            <h4 className="flex items-center gap-1.5 text-sm font-semibold text-secondary-300">
              讨论板块
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {boards.slice(0, 5).map((board) => (
                <li key={board.id}>
                  <Link
                    to={`/topics?board=${board.id}`}
                    className="text-primary-100/85 transition-colors hover:text-background-50"
                  >
                    {board.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="flex items-center gap-1.5 text-sm font-semibold text-secondary-300">
              热门内容
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link
                  to="/topic/small-things-that-made-you-laugh"
                  className="text-primary-100/85 transition-colors hover:text-background-50"
                >
                  今日话题：快乐碎片
                </Link>
              </li>
              <li>
                <Link
                  to="/topic/before-you-jump-to-conclusions"
                  className="text-primary-100/85 transition-colors hover:text-background-50"
                >
                  理性吃瓜的慢半拍方法
                </Link>
              </li>
              <li>
                <Link
                  to="/topic/friendship-drifted-apart"
                  className="text-primary-100/85 transition-colors hover:text-background-50"
                >
                  走远的友情要不要挽回
                </Link>
              </li>
              <li>
                <Link
                  to="/topic/workday-bento-formula"
                  className="text-primary-100/85 transition-colors hover:text-background-50"
                >
                  工作日便当 5 个公式
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="flex items-center gap-1.5 text-sm font-semibold text-secondary-300">
              逛一逛
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {helpLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-primary-100/85 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-700/70 pt-6 text-xs text-primary-100/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 {siteInfo.name} · 一个认真说话的线上唠嗑现场</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>社区内容由瓜友分享，观点仅代表发帖人</span>
            <Link to="/about" className="transition-colors hover:text-background-50">
              联系我们
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}